import { render, staticRenderFns } from "./submenu-divider.vue?vue&type=template&id=4d13ffed&scoped=true&"
import script from "./submenu-divider.vue?vue&type=script&lang=js&"
export * from "./submenu-divider.vue?vue&type=script&lang=js&"
import style0 from "./submenu-divider.vue?vue&type=style&index=0&id=4d13ffed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d13ffed",
  null
  
)

export default component.exports